import { useAirdropValueStore } from "@/modules/airdrop/store/value";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { constants } from "@/modules/calculations/consts";
import { useTranslation } from "react-i18next";

const WillReceive = () => {
  const { t } = useTranslation();

  const { airdrop, airdropBASE, tonPrice, price } = useUserStore();

  const { currentToken, net } = useAirdropValueStore();

  const toBTN = (tonAmount: number) => {
    if (!tonPrice || !price) return 0;
    return (tonAmount * tonPrice) / price;
  };

  const airdropWithFee = airdrop.ton - (airdrop.fee || 0);
  const airdropWithFeeUSD = airdropWithFee * tonPrice;

  const amount =
    net === "base"
      ? airdropBASE.token
      : currentToken === "token" || currentToken === ""
      ? toBTN(airdrop.ton)
      : airdropWithFee;

  const amountUSD =
    net === "base"
      ? airdropBASE.usd
      : currentToken === "token" || currentToken === ""
      ? toBTN(airdrop.ton)
      : airdropWithFeeUSD;

  const precision =
    currentToken === "token" || currentToken === "" || net === "base"
      ? constants.TOKEN_DECIMALS
      : constants.TON_DECIMALS;

  return (
    <div className="flex w-full flex-col">
      <p className="p-4 pb-2 text-[1rem] leading-[1.3125rem] font-semibold text-text tracking-tighter">
        {t("withdraw-page.will_receive")}
      </p>
      <div className="w-full flex items-center justify-between gap-4 px-4 py-0.5 bg-bg rounded-[0.75rem]">
        <div className="flex items-center gap-4">
          <img
            src={
              currentToken === "token" || currentToken === "" || net === "base"
                ? "/images/BTN.png"
                : "/images/TON.png"
            }
            alt=""
            className="w-7 h-7"
          />

          <div className="flex flex-col py-3 gap-0.5">
            <p className="text-[1.0625rem] leading-[1.375rem] font-medium text-text">
              {t("withdraw-page.token_amount", {
                token:
                  currentToken === "token" ||
                  currentToken === "" ||
                  net === "base"
                    ? "BTN"
                    : "TON",
              })}
            </p>
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("withdraw-page.your_wallet")}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-end py-3 gap-0.5">
          <p className="text-[1.0625rem] leading-[1.375rem] text-text">
            {formatNumber(amount, {
              precision: precision,
            })}{" "}
            {currentToken === "token" || currentToken === "" || net === "base"
              ? "BTN"
              : "TON"}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            ≈ $
            {formatNumber(amountUSD, {
              precision: 5,
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WillReceive;
